import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import PostApiCall from "../helper/PostAPI";
import Notiflix from "notiflix";
import { useNavigate } from "react-router-dom";

const CategoryGrid = ({
  setActiveTab,
  setSearchText,
  setActive,
  windowScrollY,
}) => {
  const [menuListItems, setMenuListItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    Notiflix.Loading.Standard("Loading...");
    PostApiCall.postRequest(
      {
        catCount: "*",

        // whereClause: "",
        // columns: "*",
      },
      "GetProductVertical"
      // "getCategoryDetails"
    ).then((results) =>
      results?.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setMenuListItems(
            obj1.data.filter((dat) => dat.fld_status === "Active")
          );
          Notiflix.Loading.Remove();
        } else {
          Notiflix.Loading.Remove();
        }
      })
    );
  }, []);

  return (
    <section style={{ marginBottom: "-100px" }}>
      <Container className="py-5 my-5">
        <h2 style={{ marginTop: "-60px" }}>Popular Categories</h2>
        <div
          className="mx-0 oder-online-category"
          data-category-columns={
            menuListItems.length % 2 === 0
              ? menuListItems.length / 2
              : (menuListItems.length + 1) / 2
          }>
          {menuListItems.map((item) => (
            <div
              className="oder-online-category-card"
              key={item.selected_cat_id}>
              <div
                className="text-center mx-lg-2 mx-0 cursor-pointer"
                onClick={() => navigate(`/category/${item?.fld_route}`)}>
                <div className="item-image category-box">
                  <img
                    onClick={(e) => {
                      setActiveTab?.(item.selected_cat_id);
                      windowScrollY?.(item.selected_cat_id);
                      setSearchText?.(e.target.getAttribute("alt"));
                      setActive?.("");
                    }}
                    className="img-fluid"
                    src={item.fld_image}
                    alt={item.fld_name}
                  />
                </div>
                <p className="item-name">{item.fld_name}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default CategoryGrid;
